import * as React from 'react'
function SvgServices(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M31 17V9h-8c0-2.2-1.8-4-4-4s-4 1.8-4 4H7v8c2.2 0 4 1.8 4 4s-1.8 4-4 4v8h8c0-2.2 1.8-4 4-4s4 1.8 4 4h8v-8c2.2 0 4-1.8 4-4s-1.8-4-4-4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgServices
